import React, { useEffect, useState } from 'react';
import Media from 'react-media';
import { useHistory } from 'react-router-dom';

import PropTypes from 'prop-types';

import { useUserState } from 'contexts/auth-context';
import t from 'utils/translateFunc';
import trackingEvent from 'utils/trackingEvent';

import {
  TableGroupsArticles,
  FavoritePanel,
  Loader,
  ModalWindow,
  BodyModalAlert
} from 'components/common/Elements/Elements';

import AlertDelGroup from './parts/AlertDelGroup/AlertDelGroup';

import { getRequest, deleteRequest } from 'utils/requests';

import {
  parsForTable,
  parsForMaxAttendance,
  parsForMaxArticlesLen
} from './helpers/helpers';

import classes from './GroupsRelease.module.scss';

const GroupsRelease = ({ mixpanel, onOfNotif }) => {
  const language = useUserState().user.language;
  const username = useUserState().user.username;

  const [loading, setLoading] = useState(true);
  const [dataGropups, setDataGropups] = useState([]);

  const [modalDelGroup, setModalDelGroup] = useState(false);
  const [modalAlert, setModalAlert] = useState(false);

  const [changeForDel, setChangeForDel] = useState();
  const [changeForAlert, setChangeForAlert] = useState({});

  const [showAllList, setShowAllList] = useState(false);

  let history = useHistory();

  useEffect(() => {
    getData();
    // eslint-disable-next-line
  }, []);

  useEffect(() => {
    if (username) {
      mixpanel.track(`User ${username} enter Groups page`);
    }
    // eslint-disable-next-line
  }, [username]);

  const getData = () => {
    getRequest('/api/press-release-groups/?deleted=false')
      .then(res => {
        setDataGropups(parsForTable(res));
        setLoading(false);
        if (res.length === 0) {
          history.push(`/newrelease/first`);
        }
      })
      .catch(err => {
        console.log(err);
      });
  };

  const delGroup = () => {
    trackingEvent('delete_group', mixpanel, username);

    setLoading(true);
    deleteRequest(`/api/press-release-groups/${changeForDel}/`)
      .then(() => {
        mixpanel.track(`User ${username} del group`);
        getData();
        onOfNotif('on', t('notif', 'CAMPAIGN_DELL', language), false, '2000');
      })
      .catch(err => {
        console.log(err);
      });
    setModalDelGroup(false);
  };

  const handleDel = id => {
    trackingEvent('open_delete_group', mixpanel, username);

    setModalDelGroup(true);
    setChangeForDel(id);
  };

  const onAlert = info => {
    trackingEvent('open_receive_notif', mixpanel, username);
    setChangeForAlert(info);
    setModalAlert(true);
  };

  const ofAlert = idAlert => {
    trackingEvent('receive_notif_off', mixpanel, username);
    deleteRequest(`/api/press-release-alertsettings/${idAlert}/`)
      .then(() => {
        getData();
      })
      .catch(err => {
        console.log(err);
      });
  };

  const onShowList = () => {
    trackingEvent('show_all_groups', mixpanel, username);
    setShowAllList(!showAllList);
  };

  if (loading) {
    return <Loader />;
  }

  return (
    <>
      <ModalWindow
        headerText={t('groupsRelease', 'Q_SURE_DEL', language)}
        isOpen={modalDelGroup}
        setIsOpen={() => {
          trackingEvent('cancel_delete_group', mixpanel, username);
          setModalDelGroup(!modalDelGroup);
        }}
      >
        <AlertDelGroup
          handleCancel={() => {
            trackingEvent('cancel_delete_group', mixpanel, username);
            setModalDelGroup(false);
          }}
          handleDel={delGroup}
          idForDel={changeForDel}
        />
      </ModalWindow>
      <ModalWindow
        headerText={t('groupsRelease', 'RECEIVE_NOTIF', language)}
        isOpen={modalAlert}
        setIsOpen={() => {
          trackingEvent('cancel_receive_notif', mixpanel, username);
          setModalAlert(false);
        }}
        stylesModal={{ body: classes.modalAlertmobile }}
      >
        <BodyModalAlert
          submit={getData}
          onCancel={() => {
            setModalAlert(false);
          }}
          name={changeForAlert.title}
          id={changeForAlert.id}
          onOfNotif={onOfNotif}
        />
      </ModalWindow>
      <section className={classes.release}>
        <div className={classes.list}>
          <h2 className={classes.title}>
            <p>
              {t('mainHeader', 'ALL_RELEASES', language)}{' '}
              <span>{`(${dataGropups.length})`}</span>
            </p>
          </h2>
          <Media
            queries={{
              small: '(max-width: 1279px)'
            }}
          >
            {matches => (
              <>
                <div className={classes.wrapForMobile}>
                  <TableGroupsArticles
                    dataGropups={dataGropups}
                    onClickDel={handleDel}
                    onAlert={onAlert}
                    ofAlert={ofAlert}
                    showAllList={matches.small ? showAllList : true}
                    className={classes.table_mobile}
                  />
                </div>

                {matches.small && dataGropups.length > 5 && (
                  <div className={classes.paginBtnBox}>
                    <button className={classes.paginBtn} onClick={onShowList}>
                      {!showAllList
                        ? t('release', 'SHOW_ALL', language)
                        : t('release', 'SHOW_FOUR', language)}
                    </button>
                  </div>
                )}
              </>
            )}
          </Media>
        </div>
        <FavoritePanel
          dataFavorite1={parsForMaxAttendance(dataGropups)}
          dataFavorite2={parsForMaxArticlesLen(dataGropups)}
        />
      </section>
    </>
  );
};

GroupsRelease.propTypes = {
  mixpanel: PropTypes.object,
  onOfNotif: PropTypes.func
};

export default GroupsRelease;
